import * as carouselReducer from './modules';
import Carousel from './components/Carousel';
import CardsCarousel from './components/CardsCarousel';
import CardoCarousel from './components/CardoCarousel';

export {
  carouselReducer,
  Carousel,
  CardsCarousel,
  CardoCarousel,
};
